"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESCALATION_LEVEL = exports.TICKET_ASSIGNMENT_ERROR_CODES = exports.ASSIGNMENT_NOTIFICATION_FAILURE_FALLBACK = exports.ASSIGNMENT_NOTIFICATION_FAILURE_LABELS = exports.ASSIGNMENT_NOTIFICATION_OUTCOMES = exports.assignTicketMemberSchema = exports.TICKET_ASSIGNMENT_EVENT_TYPE_LABELS = exports.TICKET_ASSIGNMENT_EVENT_TYPES = void 0;
exports.isAssignmentEventType = isAssignmentEventType;
exports.isEscalation = isEscalation;
const zod_1 = require("zod");
const ticket_emails_js_1 = require("./ticket-emails.js");
/**
 * Assegnazione ed escalation al secondo livello (PRD-004 US-3, story #4, DEC-004): ogni ticket in
 * lavorazione ha **un responsabile** e zero o più **collaboratori**, tutti membri attivi del team.
 * Il primo assegnato diventa responsabile; il responsabile si cambia esplicitamente. L'aggiunta di
 * un membro del livello `secondo` (gruppo Sviluppo), come collaboratore o come responsabile, è
 * l'**escalation**. Ogni nuovo assegnato riceve la notifica email (solo codice, committente,
 * priorità e link: mai il testo della segnalazione, ADR-003).
 */
/** Eventi del thread dell'assegnazione (DEC-002 regola 1: ogni cambiamento è un evento). */
exports.TICKET_ASSIGNMENT_EVENT_TYPES = [
    'responsabile_assegnato',
    'responsabile_cambiato',
    'collaboratore_aggiunto',
    'collaboratore_rimosso',
];
exports.TICKET_ASSIGNMENT_EVENT_TYPE_LABELS = {
    responsabile_assegnato: 'Responsabile assegnato',
    responsabile_cambiato: 'Responsabile cambiato',
    collaboratore_aggiunto: 'Collaboratore aggiunto',
    collaboratore_rimosso: 'Collaboratore rimosso',
};
function isAssignmentEventType(type) {
    return exports.TICKET_ASSIGNMENT_EVENT_TYPES.includes(type);
}
/** Corpo di `PUT /tickets/:code/assignee` e `POST /tickets/:code/collaborators`. */
exports.assignTicketMemberSchema = zod_1.z.strictObject({
    memberId: zod_1.z.uuid({ error: 'Scegli un membro del team' }),
});
/**
 * Esito della notifica di assegnazione. L'email parte **dopo** il salvataggio dell'assegnazione,
 * che resta valida comunque (è un fatto interno): `in_invio` finché l'invio è in corso, poi
 * `inviata` o `non_inviata` con il motivo.
 */
exports.ASSIGNMENT_NOTIFICATION_OUTCOMES = ['in_invio', 'inviata', 'non_inviata'];
/** Motivo leggibile di una notifica non inviata, per codice di errore della posta. */
exports.ASSIGNMENT_NOTIFICATION_FAILURE_LABELS = {
    ...ticket_emails_js_1.MAIL_FAILURE_LABELS,
    [ticket_emails_js_1.MAIL_ERROR_CODES.invalidRecipient]: 'l’indirizzo di notifica non è valido',
};
/** Motivo di una notifica non inviata con un codice non previsto. */
exports.ASSIGNMENT_NOTIFICATION_FAILURE_FALLBACK = ticket_emails_js_1.MAIL_FAILURE_FALLBACK;
/** Codici di errore dell'assegnazione, nel campo `code` del corpo di errore dell'API. */
exports.TICKET_ASSIGNMENT_ERROR_CODES = {
    /** Il membro non esiste o non è più nel team: si assegna solo a membri attivi. */
    memberNotAssignable: 'tickets.membro_non_assegnabile',
    /** Ticket Chiuso o Scartato: nessuna assegnazione (DEC-002, stati terminali). */
    ticketTerminal: 'tickets.ticket_terminale',
    /** Il membro è già responsabile del ticket. */
    alreadyAssignee: 'tickets.gia_responsabile',
    /** Il membro è già collaboratore del ticket. */
    alreadyCollaborator: 'tickets.gia_collaboratore',
    /** Il membro non è collaboratore del ticket. */
    notCollaborator: 'tickets.non_collaboratore',
};
/** Livello del gruppo Sviluppo: aggiungerne un membro è l'escalation al secondo livello (DEC-004). */
exports.ESCALATION_LEVEL = 'secondo';
/** Vero se assegnare un membro di quel livello è un'escalation. */
function isEscalation(level) {
    return level === exports.ESCALATION_LEVEL;
}
//# sourceMappingURL=ticket-assignment.js.map